import datasList from './datasList.json';
import datas from './datas.json';

export default class ClientService {
    getAll(critere) {
        if (critere != null) {
            var retour = [];
            datasList.map(data => {
                if (data.numero.toString().includes(critere) || data.nom.toLowerCase().includes(critere.toLowerCase())) {
                    retour.push(data);
                }
                return data;
            });
            return retour;
        } else {
            return datasList;
        }
    }

    getByNumero(numero) {
        var retour = null;
        datas.map(data => {
            if (data.client.numero == numero) {
                retour = data;
                return;
            }
        });
        return retour;
    }
}


// WEBPACK FOOTER //
// ./src/services/clients/ClientService.js